import { useCallback } from "react";
import { REQUEST_ID } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import { Token } from "@sablier/v2-models";
import { vendors } from "@sablier/v2-utils";
import { useQueryClient } from "@tanstack/react-query";
import { useStreamStoreAccessor } from "./store/stream";

export default function useResetter() {
  const accessor = useStreamStoreAccessor();
  const client = useQueryClient();

  const all = useCallback(async () => {
    try {
      Token.reset();
      accessor().api.reset([]);
      await client.resetQueries({ queryKey: REQUEST_ID.stream });
    } catch (error) {
      vendors.crash.log(error);
    }
  }, [accessor, client]);

  const own = useCallback(async () => {
    try {
      const queryKey = REQUEST_ID.streamListOwned;

      Token.reset();
      accessor().api.reset(["search", "preview"]);
      await client.resetQueries({ queryKey });
    } catch (error) {
      vendors.crash.log(error);
    }
  }, [accessor, client]);

  const search = useCallback(async () => {
    try {
      const queryKey = REQUEST_ID.streamListSearch;

      Token.reset();
      accessor().api.reset(["owned", "preview"]);
      await client.resetQueries({ queryKey });
    } catch (error) {
      vendors.crash.log(error);
    }
  }, [accessor, client]);

  const plugin = useCallback(async () => {
    try {
      await client.resetQueries({ queryKey: REQUEST_ID.plugin });
    } catch (error) {
      vendors.crash.log(error);
    }
  }, [client]);

  const proxy = useCallback(async () => {
    try {
      await own();
      await client.resetQueries({ queryKey: REQUEST_ID.proxy });
      await client.resetQueries({ queryKey: REQUEST_ID.plugin });
    } catch (error) {
      vendors.crash.log(error);
    }
  }, [client, own]);

  return {
    all,
    own,
    search,
    proxy,
    plugin,
  };
}
